import { getMe } from '@/apis';
import { paths } from '@/config';
import { useQuery } from '@/utils';
import { useClipboard } from '@/utils/clipboard';

export const useHowToSalesAccountHooks = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['me'],
    queryFn: getMe,
    enabled: window.isAuthed,
  });

  const clipboard = useClipboard();

  const website = `${window.location.origin}${paths.users.profile.replace(
    ':user_id',
    (data?.id ?? 0).toString()
  )}`;

  const handleWebSiteCopy = () => {
    clipboard.copy(website);
  };

  return {
    data,
    isLoading,
    clipboard,
    handleWebSiteCopy,
    website,
    isError: !!error,
  };
};
